/** Descuentos al retirar (Colombia): GMF + desembolso + comisión Bold. Solo panel web. */

export const WITHDRAW_GMF_RATE_DEFAULT = 0.004;
export const WITHDRAW_DISBURSEMENT_FEE_DEFAULT = 2500;
export const WALLET_GATEWAY_FEE_RATE_DEFAULT = 0.0349;
export const WALLET_GATEWAY_FEE_FIXED_DEFAULT = 900;

export const getWithdrawGmfRate = (settings) =>
  (settings && settings.withdraw_gmf_rate != null)
    ? parseFloat(settings.withdraw_gmf_rate)
    : WITHDRAW_GMF_RATE_DEFAULT;

export const getWithdrawDisbursementFee = (settings) =>
  (settings && settings.withdraw_disbursement_fee != null)
    ? parseFloat(settings.withdraw_disbursement_fee)
    : WITHDRAW_DISBURSEMENT_FEE_DEFAULT;

export const getWalletGatewayFeeRate = (settings) =>
  (settings && settings.wallet_gateway_fee_rate != null)
    ? parseFloat(settings.wallet_gateway_fee_rate)
    : WALLET_GATEWAY_FEE_RATE_DEFAULT;

export const getWalletGatewayFeeFixed = (settings) =>
  (settings && settings.wallet_gateway_fee_fixed != null)
    ? parseFloat(settings.wallet_gateway_fee_fixed)
    : WALLET_GATEWAY_FEE_FIXED_DEFAULT;

export const calcWalletGatewayFee = (amount, settings) => {
  const gross = parseFloat(amount) || 0;
  if (!(gross > 0)) return 0;
  const fee = Math.round(gross * getWalletGatewayFeeRate(settings) + getWalletGatewayFeeFixed(settings));
  return Math.max(0, Math.min(fee, gross));
};

export const computeWithdrawFees = (amount, settings) => {
  const gross = parseFloat(amount) || 0;
  if (!(gross > 0)) {
    return { gross: 0, gmf: 0, disbursementFee: 0, gatewayFee: 0, totalFees: 0, net: 0 };
  }
  const gmf = Math.round(gross * getWithdrawGmfRate(settings));
  const disbursementFee = getWithdrawDisbursementFee(settings);
  const gatewayFee = calcWalletGatewayFee(gross, settings);
  const totalFees = gmf + disbursementFee + gatewayFee;
  const net = Math.max(0, gross - totalFees);
  return { gross, gmf, disbursementFee, gatewayFee, totalFees, net };
};

/** Usa comisiones guardadas en RTDB o las estima para retiros antiguos. */
export const resolveWithdrawRowFees = (row, settings) => {
  const gross = parseFloat(row?.amount) || 0;
  const hasStored = row && (
    row.netAmount != null
    || row.gmf != null
    || row.gatewayFee != null
    || row.disbursementFee != null
  );
  if (hasStored) {
    const gmf = parseFloat(row.gmf) || 0;
    const disbursementFee = parseFloat(row.disbursementFee) || 0;
    const gatewayFee = parseFloat(row.gatewayFee) || 0;
    const totalFees = gmf + disbursementFee + gatewayFee;
    const net = row.netAmount != null
      ? parseFloat(row.netAmount) || 0
      : Math.max(0, gross - totalFees);
    return { gross, gmf, disbursementFee, gatewayFee, totalFees, net };
  }
  return computeWithdrawFees(gross, settings);
};

export const getWithdrawDisburseAmount = (row, settings) => {
  const { net } = resolveWithdrawRowFees(row, settings);
  return net;
};
